export enum DashboardEvent {
  EXPORT_CSV_CLICK = 'dashboard_export_csv_click',
  EDIT_COLUMNS_CLICK = 'dashboard_edit_columns_click',
  BANNER_CLICK = 'dashboard_banner_click',
  SUPPORT_CHAT_CLICK = 'dashboard_support_chat_click',
  SUPPORT_CLICK = 'dashboard_support_click',
  CREATE_ORDER_CLICK = 'dashboard_create_order_click',
  CANCEL_ORDER_CREATION_CLICK = 'dashboard_cancel_order_creation_click',
  ORDERS_ACTIONS_CLICK = 'dashboard_orders_actions_click',
  UPLOAD_ORDERS_CLICK = 'dashboard_upoad_orders_click',
  UPLOAD_ORDERS_EXIT_CLICK = 'dashboard_upoad_orders_exit_click',
  SETTINGS_COMPANY_SAVE_CLICK = 'dashboard_settings_company_save_click',
  ADD_TEAM_MEMBERS_CLICK = 'dashboard_add_team_members_click',
  PROFILE_SAVE_CLICK = 'dashboard_profile_save_click',
  WEBHOOK_CREATE_CLICK = 'dashboard_webhook_create_click',
  API_KEYS_GENERATE_CLICK = 'dashboard_api_keys_generate_click',
  CREATE_TEMPLATE_PUBLISH_CLICK = 'dashboard_create_template_publish_click',
  DATA_CLICK = 'dashboard_data_click',
  ORDER_SETTINGS_CLICK = 'dashboard_order_settings_click',
  BRANDING_CLICK = 'dashboard_branding_click',
  DOWNLOAD_PDF_CLICK = 'dashboard_download_pdf_click',
  DOWNLOAD_BORROWER_INFO_CLICK = 'dashboard_download_borrower_info_click',
  POPUP_SHOW = 'dashboard_popup_show',
  REFRESH_DATA_CLICK = 'dashboard_refresh_data_click',
  REFRESH_DATA_CONTINUE_CLICK = 'dashboard_refresh_data_continue_click',
  COVERAGE_SEARCH_CLICK = 'dashboard_coverage_search_click',
}
